import { PropsWithChildren } from "react"
import { BaseTable } from "components"

export function TableSection(params: PropsWithChildren<{ textLeft?: boolean }>): JSX.Element {
  return (
    <BaseTable plain>
      <tbody>
        {params.children}
      </tbody>
    </BaseTable>
  )
}

function Row(params: {
  className?: string
  label: string
  value: string
}): JSX.Element {
  return (
    <tr className={params.className}>
      <td className="w-[100px] whitespace-nowrap text-left">{params.label}</td>
      <td className="w-[10px]">:</td>
      <td className="">{params.value}</td>
    </tr>
  )
}

TableSection.Row = Row